var _circle, _path, _path2, _circle2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThirdPartyRisk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F0F1F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M36.68 13H33.32C32.591 13 32 13.591 32 14.32V17.68C32 18.409 32.591 19 33.32 19H36.68C37.409 19 38 18.409 38 17.68V14.32C38 13.591 37.409 13 36.68 13Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M29.5 16.0264H18.6667C21.9767 16.0264 24.66 18.7097 24.66 22.0198L24.66 30.1398C24.66 33.0869 26.7872 35.5373 29.59 36.0392M24.2733 19.8933C25.4333 22.9866 26.8024 25.5208 29.88 26.08",
    stroke: "#071A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0267,
    cy: 16.0267,
    r: 4.02667,
    stroke: "#071A24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M36.68 33H33.32C32.591 33 32 33.591 32 34.32V37.68C32 38.409 32.591 39 33.32 39H36.68C37.409 39 38 38.409 38 37.68V34.32C38 33.591 37.409 33 36.68 33Z",
    fill: "#071A24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M36.68 23H33.32C32.591 23 32 23.591 32 24.32V27.68C32 28.409 32.591 29 33.32 29H36.68C37.409 29 38 28.409 38 27.68V24.32C38 23.591 37.409 23 36.68 23Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThirdPartyRisk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thirdPartyRisk.e514a2876fb27dfc0777293668b3f360.svg";